import type { Middleware } from '@nuxt/types';
import { SIGN_UP_MODAL } from '@/constants/dynamicModals';

/**
 * We redirect in case old redirections from external websites result in `war-room-sign-up`.
 * @example `?dynamic_modal=war-room-sign-up` -> `?dynamic_modal=sign-up`
 */
const signupModal: Middleware = ({ app, route }) => {
  const oldSignUpKey = 'war-room-sign-up';
  const {
    query: { dynamic_modal },
  } = route;

  if (dynamic_modal === oldSignUpKey) {
    app.$utils.redirectWithQuery({ path: route.path }, { query: { ...route.query, dynamic_modal: SIGN_UP_MODAL } });
  }
};

export default signupModal;
